var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"key-con"},[_c('div',{staticClass:"keyboardContainer",class:[_vm.keyboardType]},[_c('div',{class:_vm.keyboardClass})]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGesture),expression:"showGesture"}],staticClass:"gesture"},[_c('div',{staticClass:"left_gesture",style:({
        backgroundImage: `url(${_vm.leftGestureDa})`,
      })}),_c('div',{class:{
        right_gesture: true,
        right_top_row: _vm.rightGestureKey.includes('right-top-row'),
        right_bottom_row: _vm.rightGestureKey.includes('right-bottom-row'),
      },style:({
        backgroundImage: `url(${_vm.rightGestureDa})`,
      })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }